import {
  EcommercePerformanceAction,
  LOAD_ECOMMERCE_PERFORMANCE_NOW, LOAD_ECOMMERCE_PERFORMANCE_NOW_FAIL, LOAD_ECOMMERCE_PERFORMANCE_NOW_SUCCESS,
  LoadEcommercePerformanceNow,
  LoadEcommercePerformanceNowFail,
  LoadEcommercePerformanceNowSuccess
} from "../actions";

export interface IEcommercePerformanceNowEntityState {
  dataForToday: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommercePerformanceNowState {
  entities: { [websiteId: number]: IEcommercePerformanceNowEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommercePerformanceNowState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommercePerformanceNowState = initialState, action: EcommercePerformanceAction): IEcommercePerformanceNowState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PERFORMANCE_NOW:
      payload = (<LoadEcommercePerformanceNow>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PERFORMANCE_NOW_SUCCESS:
      payload = (<LoadEcommercePerformanceNowSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            dataForToday: payload.dataForToday,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PERFORMANCE_NOW_FAIL:
      payload = (<LoadEcommercePerformanceNowFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
